module.exports = __webpack_public_path__ + "img/2.9eb56896.png";